import { PartyPopper } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Rsvp({ datos, seccion, acciones }) {
  const rsvp = datos.rsvp || {};

  return (
    <section className="ki-seccion ki-rsvp" aria-label={seccion.titulo}>
      <div className="ki-seccion-interior">
        <EncabezadoSeccion p="ki" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="ki-titulo-rsvp" />
        <Reveal delay={0.1}>
          {rsvp.mensaje && <p className="ki-rsvp-mensaje">{rsvp.mensaje}</p>}
          {rsvp.fechaLimite && <p className="ki-rsvp-limite">{rsvp.fechaLimite}</p>}
          <button
            type="button"
            className="ki-boton ki-boton--claro"
            onClick={() => acciones?.onConfirmarAsistencia?.()}
            data-testid="ki-boton-rsvp"
          >
            <PartyPopper strokeWidth={2} />
            {rsvp.textoBoton || "Confirmar asistencia"}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
